import React, { Children, useEffect, useState } from 'react'
import { ConfigProvider, theme as antdTheme } from 'antd'
import { CookiesProvider } from 'react-cookie'
import { IntlProvider } from 'react-intl'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import history from './history'
import App from './components/App'
import { locale, translations } from './Locale'
import {
  DARK_MODE,
  WHITE_COLOR,
  GUNMETAL_COLOR,
  BLACK_COLOR,
  BRIGHT_GREY_COLOR,
  GRAY_COLOR,
  MEDIUM_GRAY_COLOR,
} from './constants'
import { themeComponentCreator } from './ComponentThemeGenerator'
import { customThemeGenerator } from './CustomTheme'
import { useSelector, shallowEqual } from 'react-redux'
import { isWindowBelowMinHeight } from './helpers/utils'

const queryClient = new QueryClient()

export const AntConfigProvider = ({ children }) => {
  const theme = useSelector((state) => state.app.theme, shallowEqual)
  const { defaultAlgorithm, darkAlgorithm } = antdTheme

  return (
    <ConfigProvider
      theme={{
        algorithm: theme == DARK_MODE ? darkAlgorithm : defaultAlgorithm,
        components: { ...themeComponentCreator(theme) },
        token: {
          fontFamily: 'Montserrat',
          colorBgLayout:
            theme == DARK_MODE ? GUNMETAL_COLOR : BRIGHT_GREY_COLOR,
          colorLink: theme == DARK_MODE ? WHITE_COLOR : BLACK_COLOR,
          colorLinkHover: theme == DARK_MODE ? MEDIUM_GRAY_COLOR : GRAY_COLOR,
          fontSize: isWindowBelowMinHeight() ? 12 : 14,
          padding: isWindowBelowMinHeight() ? 10 : 16,
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

/* Define Root with Route Provider */
export default function Root() {
  const theme = useSelector((state) => state.app.theme, shallowEqual)
  const [customTheme, setCustomTheme] = useState(customThemeGenerator(theme))

  useEffect(() => {
    setCustomTheme(customThemeGenerator(theme))
  }, [theme])

  return (
    <AntConfigProvider>
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale={locale} messages={translations}>
          <CookiesProvider>
            <ConnectedRouter history={history}>
              <Switch>
                <Route>
                  <App customTheme={customTheme} />
                </Route>
              </Switch>
            </ConnectedRouter>
          </CookiesProvider>
        </IntlProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AntConfigProvider>
  )
}
